package it.neckar.lizergy.model.company

import kotlinx.serialization.Serializable

/**
 * For use in PV only!
 */
@Serializable
data class PvBankInformation(
  val name: String,
  val iban: String,
  val bic: String,
) {

  /**
   * Returns true if all properties are set
   */
  val isPlausible: Boolean
    get() {
      return name.isNotBlank()
        && iban.isNotBlank()
        && bic.isNotBlank()
    }

  companion object {
    val empty: PvBankInformation = PvBankInformation("", "", "")
    val demo: PvBankInformation = PvBankInformation("VR Bank Steinlach-Wiesaz-Härten", "DE 40 5555 6666 7777 8888 99", "GENODES1STW")
    val Schnitzer: PvBankInformation = PvBankInformation("VR Bank Steinlach-Wiesaz-Härten", "DE 40 6406 1854 0115 0760 00", "GENODES1STW")
    val Lizergy: PvBankInformation = PvBankInformation("Volksbank Horb-Freudenstadt", "DE 4564 2910 10 00 9154 0003", "GENODES1FDS")

    @Deprecated("Use empty instead")
    val NeckarIT: PvBankInformation = PvBankInformation("", "", "")
  }

}
